module.exports = __webpack_public_path__ + "static/media/codePeaches.b602fce0.gif";